import { useEffect, useMemo, useState } from "react";

/* ✅ ICONOS (ajusta rutas/nombres a los tuyos) */
import DireccionIcon from "../../assets/img/icons/direccion-general.png";
import ProgramasIcon from "../../assets/img/icons/proyectos.png";
import PsicosocialIcon from "../../assets/img/icons/intervencion-psicosocial.png";
import InsercionIcon from "../../assets/img/icons/insercion-laboral.png";
import ComunicacionIcon from "../../assets/img/icons/comunicaciones.png";
import JuridicaIcon from "../../assets/img/icons/juridico.png";

function Organization() {
  const areas = useMemo(
    () => [
      {
        id: "programas",
        icon: ProgramasIcon,
        title: "Área de programas\ny proyectos",
        group: "top",
        description:
          "La dirección de programas, proyectos y planeación estratégica de la Fundación ARDUVI es la dependencia encargada de la planeación, estructuración, ejecución y seguimiento, desde el modelo de atención e intervención psicosocial e inserción socio laboral de los proyectos sociales que implementa la organización en sus distintos frentes y fases. También, es la encargada de desarrollar y garantizar la implementación de las técnicas y herramientas necesarias para la ejecución de los proyectos, desde un enfoque de acción participativa, satisfacción de los participantes y contrapartes de la fundación, basados en la efectividad, eficiencia y eficacia logrando cumplir con los resultados previstos, dentro de unas condiciones dadas de alcance, tiempo y presupuesto asignado.",
      },
      {
        id: "psicosocial",
        icon: PsicosocialIcon,
        title: "Área de intervención\ny atención psicosocial",
        group: "sideLeft",
        description:
          "El área psicosocial y de intervención de psicología clínica de la Fundación ARDUVI es la encargada de realizar acciones de intervención y acompañamiento a la población en condición de discapacidad, migrantes y víctimas de violencias. Dichas acciones se desarrollan desde el modelo propio de la fundación para la atención psicosocial e inserción sociolaboral basados en el enfoque ecosistémico y en comunidad, desde la gestoría de casos para la identificación, evaluación, coordinación de recursos y psicología clínica, activando servicios necesarios para satisfacer las necesidades individuales y familiares que afectan al sistema en su conjunto.",
      },
      {
        id: "insercion",
        icon: InsercionIcon,
        title: "Área de inserción\nsocio-laboral",
        group: "sideRight",
        description:
          "El área de inserción sociolaboral de la Fundación ARDUVI es la encargada de establecer estrategias de promoción, formación, facilitación y acompañamiento a las poblaciones en situación de discapacidad, vulnerabilidad, migrantes y víctimas de violencias como estrategia de apoyo e inserción al mundo laboral, de la generación de proyectos productivos o de integración socioeconómica. Desde esta área se promueve la inclusión social, la autonomía y el desarrollo integral de las y los participantes en colaboración con otras organizaciones y entidades del sector público, privado y la cooperación internacional a fin de garantizar el acceso a servicios y recursos que puedan beneficiar a la población de interés, desde programas de capacitación, inscripción en agencias públicas de empleo, proyectos orientados a fortalecer medios de vida y la búsqueda activa de oportunidades en el mercado laboral.",
      },
      {
        id: "comunicacion",
        icon: ComunicacionIcon,
        title: "Área de comunicación\ny marketing digital",
        group: "bottomLeft",
        description:
          "El área de comunicaciones y marketing digital de la Fundación se ocupa de elaborar y difundir información relevante sobre las actividades, objetivos y logros de la organización. Esto incluye la creación de estrategias de comunicación, abordando las relaciones públicas, el manejo de redes sociales, la elaboración de material promocional y la interacción con medios de comunicación para fortalecer su imagen y visibilidad. Al mismo tiempo, comprende la coordinación de eventos y campañas para aumentar el conocimiento público y el apoyo a la misión institucional.",
      },
      {
        id: "juridica",
        icon: JuridicaIcon,
        title: "Área Jurídica,\nde Talento Humano\ny Gestión de la calidad",
        group: "bottomRight",
        description: (
          <div className="space-y-5">
            <p>
              El área jurídica, de talentos humanos y gestión de calidad de la
              Fundación ARDUVI, desarrolla tres grandes procesos orientados a
              garantizar el cumplimiento del propósito de la organización:
            </p>

            <ul className="list-disc pl-5 space-y-4">
              <li>
                <span className="font-semibold text-slate-900">
                  Área Jurídica:
                </span>{" "}
                Se encarga de elaborar y proyectar todos los instrumentos
                jurídicos que permitan dar la viabilidad y el soporte legal de la
                Fundación para la firma de acuerdos, convenios, memorandos de
                entendimiento y contratos requeridos. También, propende por
                brindar asesoría jurídica adecuada en el cumplimiento de la
                misionalidad de la fundación.
              </li>

              <li>
                <span className="font-semibold text-slate-900">
                  Área de Talentos Humanos:
                </span>{" "}
                Es el área encargada de la gestión del talento de la fundación a
                través del análisis de los puestos de trabajo, el
                reclutamiento/contratación y la selección de personal, la
                formación y el desarrollo humano desde el liderazgo
                transformacional, la compensación y los beneficios, la gestión
                del rendimiento, las relaciones humanas y laborales del equipo
                humano de la fundación con relación al cumplimiento del objeto
                misional. Para la Fundación ARDUVI cuando el talento humano crece
                y desarrolla sus habilidades, la organización experimenta
                automáticamente un crecimiento y una expansión.
              </li>

              <li>
                <span className="font-semibold text-slate-900">
                  Área de gestión de la calidad:
                </span>{" "}
                Es el área encargada de asegurar que los bienes, productos o
                servicios que ofrece la fundación a sus participantes, familias
                y contrapartes cumplan con los estándares de calidad
                establecidos. Esto implica la implementación de procesos,
                controles y sistemas para monitorear y mejorar la calidad de los
                bienes, productos o servicios garantizando su satisfacción. El
                área de gestión de calidad tiene a su cargo la elaboración de
                políticas de calidad, la realización de auditorías internas, la
                gestión de reclamos de participantes, familias y contrapartes y
                la capacitación del personal en temas relacionados con la
                calidad. Su objetivo principal es asegurar que la organización
                cumpla con los requisitos de calidad y continúe mejorando sus
                procesos y productos.
              </li>
            </ul>
          </div>
        ),
      },
    ],
    []
  );

  const direccionGeneral = useMemo(
    () => ({
      id: "direccion",
      icon: DireccionIcon,
      title: "Dirección General",
      pill: "Junta Directiva",
      description: (
        <div className="space-y-5">
          <p>
            La dirección general de la Fundación ARDUVI es la encargada de
            coordinar y supervisar desde la corresponsabilidad todas las
            actividades y operaciones que se ejecutan por las direcciones y áreas
            de la fundación.
          </p>

          <ul className="list-disc pl-5 space-y-3">
            <li>
              Coordina el cumplimiento de la visión, misión y plan estratégico de
              la fundación desde sus distintas líneas de intervención para el
              cumplimiento de sus objetivos desde la eficiencia y eficacia.
            </li>
            <li>
              Supervisa la implementación del Modelo ARDUVI “Inclusión con Amor”
              en su desarrollo a través de los distintos programas y proyectos.
            </li>
            <li>
              Gestiona los recursos financieros y humanos necesarios para
              garantizar la operación, sostenibilidad y el aumento del impacto en
              la cobertura de la fundación.
            </li>
            <li>
              Representa a la fundación legal y jurídicamente ante las instancias
              correspondientes y los stakeholders externos como donantes,
              gobiernos y comunidades.
            </li>
            <li>
              Asegura el cumplimiento de las normativas legales y éticas
              nacionales vigente, así como de los principios, valores y líneas
              estratégicas de la organización.
            </li>
            <li>
              Reporta a la junta directiva sobre el desempeño, logros de la
              fundación y cumplimiento del plan estratégico de la organización.
            </li>
          </ul>
        </div>
      ),
    }),
    []
  );

  const [openId, setOpenId] = useState(null);

  const openArea =
    openId === "direccion"
      ? direccionGeneral
      : areas.find((a) => a.id === openId);

  // Cerrar con ESC
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setOpenId(null);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  // Bloquea scroll del body cuando modal está abierto
  useEffect(() => {
    if (!openArea) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [openArea]);

  // ✅ posiciones SOLO para PC (md+)
  const posClassDesktop = {
    top: "left-1/2 -translate-x-1/2 top-4",
    sideLeft: "left-2 top-1/2 -translate-y-1/2",
    sideRight: "right-2 top-1/2 -translate-y-1/2",
    bottomLeft: "left-6 bottom-4",
    bottomRight: "right-6 bottom-4",
  };

  const NodeButton = ({ area, compact = false }) => (
    <button
      type="button"
      onClick={() => setOpenId(area.id)}
      className={
        "w-full rounded-2xl bg-blue-700 text-white shadow-lg ring-1 ring-white/20 " +
        "hover:bg-blue-800 hover:scale-[1.02] hover:shadow-xl transition duration-300 " +
        (compact ? "px-3 py-3 text-sm" : "px-4 py-3 text-base") +
        " text-center font-semibold leading-snug whitespace-pre-line " +
        "focus:outline-none focus:ring-4 focus:ring-yellow-300/40"
      }
    >
      {area.title}
    </button>
  );

  const top = areas.find((a) => a.group === "top");
  const sideLeft = areas.find((a) => a.group === "sideLeft");
  const sideRight = areas.find((a) => a.group === "sideRight");
  const bottomLeft = areas.find((a) => a.group === "bottomLeft");
  const bottomRight = areas.find((a) => a.group === "bottomRight");

  const modalTitle = openArea?.title || "";
  const modalDescription = openArea?.description || "";

  // ✅ Render formal para textos string (los convierte a párrafos bonitos)
  const renderStringAsProse = (text) => {
    const clean = String(text || "").trim();
    if (!clean) return null;

    const parts = clean
      .replace(/\s+/g, " ")
      .split(/(?<=\.)\s+(?=[A-ZÁÉÍÓÚÑ])/g)
      .filter(Boolean);

    return (
      <div className="space-y-4">
        {parts.map((p, idx) => (
          <p key={idx}>{p}</p>
        ))}
      </div>
    );
  };

  return (
    <section className="bg-no-repeat bg-cover bg-fixed">
      <h2 className="text-3xl text-center font-bold tracking-tight text-yellow-button sm:text-4xl py-8">
        Nuestro Organigrama
      </h2>

      <div className="container mx-auto px-4 pb-16">
        {/* ✅ MOBILE */}
        <div className="md:hidden">
          <div className="rounded-3xl bg-white shadow-xl ring-1 ring-black/5 p-4 overflow-hidden">
            {/* Top */}
            <div className="flex justify-center">
              <div className="w-full max-w-[320px]">
                <NodeButton area={top} />
              </div>
            </div>

            {/* línea vertical */}
            <div className="mx-auto my-4 h-14 w-[6px] rounded-full bg-blue-200" />

            {/* Centro (clickeable) */}
            <div className="flex justify-center">
              <div className="w-full max-w-[340px]">
                <button
                  type="button"
                  onClick={() => setOpenId("direccion")}
                  className="w-full rounded-[26px] bg-blue-800 text-white shadow-2xl ring-1 ring-white/20 px-6 py-6 text-center hover:scale-[1.01] transition focus:outline-none focus:ring-4 focus:ring-yellow-300/40"
                >
                  <div className="text-lg font-extrabold">Dirección General</div>
                  <div className="mt-3 inline-flex items-center justify-center rounded-full bg-white/10 px-5 py-2 text-sm font-semibold">
                    Junta Directiva
                  </div>
                </button>
              </div>
            </div>

            {/* Laterales -> en móvil: 2 columnas */}
            <div className="mt-4 grid grid-cols-2 gap-3">
              <NodeButton area={sideLeft} compact />
              <NodeButton area={sideRight} compact />
            </div>

            {/* líneas hacia abajo */}
            <div className="relative mt-5 h-10">
              <div className="absolute left-1/2 top-0 -translate-x-1/2 h-full w-[6px] rounded-full bg-blue-200" />
              <div className="absolute left-1/2 top-6 -translate-x-1/2 w-[85%] h-[6px] rounded-full bg-blue-200" />
            </div>

            {/* Abajo -> en móvil: 2 columnas */}
            <div className="mt-2 grid grid-cols-2 gap-3">
              <NodeButton area={bottomLeft} compact />
              <NodeButton area={bottomRight} compact />
            </div>
          </div>
        </div>

        {/* ✅ DESKTOP (mapa mental) */}
        <div className="hidden md:block">
          <div className="relative mx-auto w-full max-w-6xl">
            <div className="relative h-[560px] lg:h-[620px] rounded-3xl bg-white shadow-xl ring-1 ring-black/5 overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-b from-slate-50 to-white" />

              {/* líneas */}
              <svg
                className="absolute inset-0 w-full h-full"
                viewBox="0 0 1000 600"
                preserveAspectRatio="none"
                aria-hidden="true"
              >
                <line
                  x1="500"
                  y1="300"
                  x2="500"
                  y2="90"
                  stroke="rgba(37,99,235,0.25)"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
                <line
                  x1="500"
                  y1="300"
                  x2="860"
                  y2="300"
                  stroke="rgba(37,99,235,0.25)"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
                <line
                  x1="500"
                  y1="300"
                  x2="740"
                  y2="520"
                  stroke="rgba(37,99,235,0.25)"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
                <line
                  x1="500"
                  y1="300"
                  x2="260"
                  y2="520"
                  stroke="rgba(37,99,235,0.25)"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
                <line
                  x1="500"
                  y1="300"
                  x2="140"
                  y2="300"
                  stroke="rgba(37,99,235,0.25)"
                  strokeWidth="10"
                  strokeLinecap="round"
                />
              </svg>

              {/* centro (clickeable) */}
              <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
                <button
                  type="button"
                  onClick={() => setOpenId("direccion")}
                  className="rounded-[28px] bg-blue-800 text-white shadow-2xl ring-1 ring-white/20 px-10 py-8 text-center hover:scale-[1.01] transition focus:outline-none focus:ring-4 focus:ring-yellow-300/40"
                >
                  <div className="text-xl lg:text-2xl font-extrabold">
                    Dirección General
                  </div>
                  <div className="mt-3 inline-flex items-center justify-center rounded-full bg-white/10 px-5 py-2 text-sm lg:text-base font-semibold">
                    Junta Directiva
                  </div>
                </button>
              </div>

              {/* nodos */}
              {areas.map((a) => (
                <div
                  key={a.id}
                  className={
                    "absolute " +
                    posClassDesktop[a.group] +
                    " w-[230px] lg:w-[260px] p-3"
                  }
                >
                  <NodeButton area={a} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* ✅ MODAL / BANNER */}
      {openArea && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4"
          role="dialog"
          aria-modal="true"
          aria-label="Detalle del área"
        >
          {/* overlay */}
          <button
            type="button"
            className="absolute inset-0 bg-slate-950/55 backdrop-blur-[3px]"
            onClick={() => setOpenId(null)}
            aria-label="Cerrar"
          />

          {/* tarjeta */}
          <div className="relative w-full max-w-4xl rounded-[28px] bg-white shadow-2xl ring-1 ring-black/10 overflow-hidden">
            {/* header */}
            <div className="px-6 sm:px-9 py-6 border-b border-slate-100">
              <div className="flex items-start gap-4">
                {/* ✅ ICONO (reemplaza la A) */}
                <div className="shrink-0">
                  <div className="h-14 w-14 rounded-2xl bg-blue-50 ring-1 ring-blue-100 flex items-center justify-center overflow-hidden">
                    {openArea?.icon ? (
                      <img
                        src={openArea.icon}
                        alt={modalTitle}
                        className="w-9 h-9 object-contain"
                      />
                    ) : (
                      <span className="text-blue-800 font-extrabold text-lg">
                        •
                      </span>
                    )}
                  </div>
                </div>

                <div className="min-w-0 flex-1">
                  <h3 className="text-slate-900 text-xl sm:text-2xl font-extrabold whitespace-pre-line leading-snug">
                    {modalTitle}
                  </h3>
                </div>

                {/* close */}
                <button
                  type="button"
                  onClick={() => setOpenId(null)}
                  className="shrink-0 rounded-full bg-slate-100 px-3 py-2 text-slate-700 font-bold hover:bg-slate-200 transition"
                  aria-label="Cerrar"
                  title="Cerrar"
                >
                  ✕
                </button>
              </div>
            </div>

            {/* body */}
            <div className="px-6 sm:px-9 py-7">
              <div className="text-slate-700 leading-7 text-[15px] sm:text-base">
                {typeof modalDescription === "string"
                  ? renderStringAsProse(modalDescription)
                  : modalDescription}
              </div>
            </div>

            {/* footer */}
            <div className="px-6 sm:px-9 py-6 border-t border-slate-100 bg-slate-50">
              <div className="flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-3">
                <button
                  type="button"
                  onClick={() => setOpenId(null)}
                  className="rounded-xl bg-white px-6 py-3 font-semibold text-slate-800 ring-1 ring-slate-200 hover:bg-slate-100 transition"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Organization;